export default "__VITE_ASSET__39e07715__"